<template>
<div class="main-bg">
    <div class="map-page">
      <div class="map">

      <!-- Mt. Fuji Background-->
      <img class="fuji" src="/assets/images/survival/fuji.svg" alt="Mt. Fuji"> 

      <!-- Survival: Choose One-->
      <div class="survival-choose-one">
        <p>Survival</p>
        <p>Choose one</p>
      </div>


      <!-- Flags -->
      <!-- Hiragana -->
      <a class="map-click hiragana" @click.prevent="selectSection('hiragana')">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 132 65" style="enable-background:new 0 0 132 65;" xml:space="preserve">

        <!-- Shadow -->
        <defs>
          <filter id="shadow">
            <feDropShadow dx="0" dy="0" stdDeviation="3"
                flood-color="#ddd"/>
          </filter>
        </defs>  
        
        <path class="st0" d="M129.7,2c0-0.6,0.4-1,1-1s1,0.4,1,1v63h-2V2z"/>
        <g>
          <path class="flag-locked flag-unlocked" d="M129.7,2v44H2.2c-0.7,0-1.2-0.7-0.9-1.3l7-19.3c0.3-0.9,0.3-1.9,0-2.7l-7-19.3C1,2.7,1.5,2,2.2,2H129.7z"/>
          <path class="flag-arrow-locked flag-arrow-unlocked" d="M109.6,17c0.6-0.6,1.5-0.6,2.1-0.1l7.7,7.1l-7.7,7.1c-0.6,0.6-1.6,0.5-2.1-0.1c-0.6-0.6-0.5-1.6,0.1-2.1
            L115,24l-5.3-4.9C109.1,18.6,109.1,17.6,109.6,17z"/>
          <text transform="matrix(1 0 0 1 38.5767 30.9424)" class="flag-text-locked flag-text-unlocked">ひらがな</text>
          <text transform="matrix(1 0 0 1 17.8652 31.1211)" class="hidden visible flag-number">1.</text>  
          <path class="flag-lock hidden" d="M31.3,23.2h-0.8V21c0-2.6-2.2-4.8-4.8-4.8c-2.6,0-4.8,2.2-4.8,4.8v2.2h-0.8c-0.8,0-1.5,0.7-1.5,1.5v6
            c0,0.8,0.7,1.5,1.5,1.5h11c0.8,0,1.5-0.7,1.5-1.5v-6C32.8,23.9,32.1,23.2,31.3,23.2z M27.1,28.5c0,0.7-0.6,1.2-1.2,1.2
            c-0.7,0-1.2-0.5-1.2-1.2V27c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2V28.5z M28.1,23.2h-4.5V21c0-1.2,1-2.2,2.2-2.2
            c1.2,0,2.2,1,2.2,2.2V23.2z"/>
        </g>
        </svg>
      </a>
      <!-- Katakana -->
      <a class="map-click katakana" @click.prevent="selectSection('katakana')">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 133 65" style="enable-background:new 0 0 133 65;" xml:space="preserve">
        <path class="st0" d="M0.1,2c0-0.6,0.4-1,1-1s1,0.4,1,1v63h-2V2z"/>
        <g>
          <path class="flag-locked flag-unlocked" d="M132.6,44.7c0.2,0.7-0.2,1.3-0.9,1.3H2.1V2h129.6c0.7,0,1.2,0.7,0.9,1.3l-7,19.3c-0.3,0.9-0.3,1.9,0,2.7
            L132.6,44.7z"/>
          <path class="flag-arrow-locked flag-arrow-unlocked" d="M105,17c0.6-0.6,1.5-0.6,2.1-0.1l7.7,7.1l-7.7,7.1c-0.6,0.6-1.6,0.5-2.1-0.1c-0.6-0.6-0.5-1.6,0.1-2.1l5.3-4.9
            l-5.3-4.9C104.5,18.5,104.5,17.6,105,17z"/>
          <text transform="matrix(1 0 0 1 33.7246 30.7871)" class="flag-text-locked flag-text-unlocked">カタカナ</text>
          <text transform="matrix(1 0 0 1 11.2969 30.6709)" class="hidden visible flag-number">2.</text>
          <path class="flag-lock hidden" d="M24,23.1h-0.8v-2.2c0-2.6-2.2-4.8-4.8-4.8c-2.6,0-4.8,2.2-4.8,4.8v2.2H13c-0.8,0-1.5,0.7-1.5,1.5v6
            c0,0.8,0.7,1.5,1.5,1.5h11c0.8,0,1.5-0.7,1.5-1.5v-6C25.5,23.8,24.9,23.1,24,23.1z M19.8,28.3c0,0.7-0.6,1.2-1.2,1.2
            c-0.7,0-1.2-0.5-1.2-1.2v-1.5c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2V28.3z M20.8,23.1h-4.5v-2.2c0-1.2,1-2.2,2.2-2.2
            c1.2,0,2.2,1,2.2,2.2V23.1z"/>
        </g>
        </svg>
      </a>
      <!-- Seikatsu -->
      <a class="map-click seikatsu" @click.prevent="selectSection('seikatsu')">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 130 65" style="enable-background:new 0 0 130 65;" xml:space="preserve">
        <path class="st0" d="M127.8,1.3c0-0.6,0.4-1,1-1s1,0.4,1,1v63h-2V1.3z"/>
        <g>
          <path class="flag-locked flag-unlocked" d="M127.8,1.3v44H1.2c-0.7,0-1.2-0.7-0.9-1.3l7-19.3c0.3-0.9,0.3-1.8,0-2.7l-7-19.3C0,2,0.5,1.3,1.2,1.3H127.8z"
            />
          <path class="flag-arrow-locked flag-arrow-unlocked" d="M107.7,16.3c0.6-0.6,1.5-0.6,2.1-0.1l7.7,7.1l-7.7,7.1c-0.6,0.6-1.6,0.5-2.1-0.1c-0.6-0.6-0.5-1.6,0.1-2.1
            l5.3-4.9l-5.3-4.9C107.1,17.8,107.1,16.9,107.7,16.3z"/>
          <text transform="matrix(1 0 0 1 35.4995 30.1797)" class="flag-text-locked flag-text-unlocked">せいかつ</text>
          <text transform="matrix(1 0 0 1 15.1216 30.25)" class="hidden visible flag-number">3.</text>  
          <path class="flag-lock hidden" d="M29.3,22.3h-0.8V20c0-2.6-2.2-4.8-4.8-4.8c-2.6,0-4.8,2.2-4.8,4.8v2.2h-0.8c-0.8,0-1.5,0.7-1.5,1.5v6
            c0,0.8,0.7,1.5,1.5,1.5h11c0.8,0,1.5-0.7,1.5-1.5v-6C30.8,23,30.1,22.3,29.3,22.3z M25,27.5c0,0.7-0.6,1.2-1.2,1.2
            c-0.7,0-1.2-0.5-1.2-1.2V26c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2V27.5z M26,22.3h-4.5V20c0-1.2,1-2.2,2.2-2.2
            c1.2,0,2.2,1,2.2,2.2V22.3z"/>
        </g>
        </svg>
      </a>
      <!-- Bunka -->
      <a class="map-click bunka" @click.prevent="selectSection('bunka')">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 118 65" style="enable-background:new 0 0 118 65;" xml:space="preserve">
        <path class="st0" d="M0.2,1.6c0-0.6,0.4-1,1-1s1,0.4,1,1v63h-2V1.6z"/>
        <g>
          <path class="flag-locked" :class="{ 'flag-unlocked' : ifTrueBunka }" d="M116.7,44.3c0.2,0.7-0.2,1.3-0.9,1.3H2.2v-44h113.6c0.7,0,1.2,0.7,0.9,1.3l-7,19.3c-0.3,0.9-0.3,1.9,0,2.7
            L116.7,44.3z"/>
          <path class="flag-arrow-locked" :class="{ 'flag-arrow-unlocked' : ifTrueBunka }" d="M91.1,16.6c0.6-0.6,1.5-0.6,2.1-0.1l7.7,7.1l-7.7,7.1c-0.6,0.6-1.6,0.5-2.1-0.1c-0.6-0.6-0.5-1.6,0.1-2.1
            l5.3-4.9l-5.3-4.9C90.6,18.2,90.5,17.2,91.1,16.6z"/>

          <!-- Coming Soon -->
          <text transform="matrix(1 0 0 1 33.8243 20)" style="font-size: .75em;"><tspan x="0" y="0" class="flag-text-locked" :class="{ 'flag-text-unlocked' : ifTrueBunka }">Coming</tspan><tspan x="7.6" y="14.4" class="flag-text-locked" :class="{ 'flag-text-unlocked' : ifTrueBunka }">Soon</tspan></text>
          <!-- <text transform="matrix(1 0 0 1 32.2544 29.8945)" class="flag-text-locked" :class="{ 'flag-text-unlocked' : ifTrueBunka }">ぶんか</text> -->

          <text transform="matrix(1 0 0 1 11.9209 29.5435)" class="hidden" :class="{ 'visible flag-number' : ifTrueBunka }">4.</text>  
          <path class="flag-lock" :class="{ hidden : ifTrueBunka }" d="M25.7,22.6H25v-2.2c0-2.6-2.2-4.8-4.8-4.8c-2.6,0-4.8,2.2-4.8,4.8v2.2h-0.8c-0.8,0-1.5,0.7-1.5,1.5v6
            c0,0.8,0.7,1.5,1.5,1.5h11c0.8,0,1.5-0.7,1.5-1.5v-6C27.2,23.3,26.5,22.6,25.7,22.6z M21.5,27.9c0,0.7-0.6,1.2-1.2,1.2
            c-0.7,0-1.2-0.5-1.2-1.2v-1.5c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2V27.9z M22.5,22.6H18v-2.2c0-1.2,1-2.2,2.2-2.2
            c1.2,0,2.2,1,2.2,2.2V22.6z"/>
        </g>
        </svg>
      </a>

        
      <!-- Progress  -->
      <!-- 修正中 -->
      <progressbar v-show="sectionData" :section="sectionData" :progress="Progress"></progressbar>

      </div>
    </div>
</div>  
</template>

<script>
import { api, appEnv, useCoachmark } from "../../config";
import { mapState } from "vuex";
import status from '../../mixins/status';

import ProgressBar from '../shared/ProgressBar.vue'

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

export default {
  mixins: [
    status
  ],
  components: {
    'progressbar': ProgressBar,
  },
  data() {
    return {
      step: 'top',
      authUser: null,
      ifBunka: false,
      driver: null,
      storage: {}
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth,
    }),
    sectionData() {
      return this.$store.getters.section_data;
    },
    Progress() {
      return this.$store.getters.progress ? this.$store.getters.progress : 0;
    },
    ifTrueBunka() {
      return this.ifBunka
    }
  },

  created() {
    
    let self = this;
    self.$store.dispatch("showLoading", true);

    
    self.$store.dispatch('getNewsList')
      
    // 1. Get authUser
    this.authUser = this.$store.getters.getAuthUser;
    if(this.authUser) {
      
      // 2. Get progress
      axios.get(api.progress)
      .then((resp) => {
        self.$store.dispatch('setProgress', resp.data.progress_rate)

        // 3. If the progress is 100%, check the status of the section
        if (resp.data.progress_rate > 0 && resp.data.progress_rate %100 == 0) {
          self.$store.dispatch('setProgress', 0)
        }
      });
      
      
      // check auth
      axios.get(api.currentUser)
      .then((resp) => {
          this.$store.dispatch('setAuthUser', resp.data)
      }).catch(err => {
          // Sessionにあるのにサーバーでは非ログインなのでエラー
          self.$store.dispatch('unsetAuthUser');
          this.$router.push({name: 'login'});
      });
    } else {
      // check auth
      axios.get(api.currentUser)
      .then((resp) => {
          self.$store.dispatch('setAuthUser', resp.data)
          
          // 2. Get progress
          axios.get(api.progress)
          .then((resp) => {
            self.$store.dispatch('setProgress', resp.data.progress_rate)

            // 3. If the progress is 100%, check the status of the section
            if (resp.data.progress_rate > 0 && resp.data.progress_rate %100 == 0) {
              self.$store.dispatch('setProgress', 0)
            }
          });
      
      }).catch(err => {
          // Sessionにあるのにサーバーでは非ログインなのでエラー
          self.$store.dispatch('unsetAuthUser');
          self.$router.push({name: 'login'});
      });
    }
    
    
    if(this.driver) {
      this.driver.reset();
    } else {
      this.initCoachMark();
    }
  },

  mounted() {
    let self = this;
    
    axios.get(api.section)
    .then(function(resp) {
      self.$store.dispatch("setSection", resp.data.section);

      let section_list = self.$store.getters.section
      for (let section in section_list) {
        if ( section_list[section].status == 'ready'
          || section_list[section].status == 'start'
          || section_list[section].status == 'completed') {
          
          self.$store.dispatch("setSectionData", self.$store.getters.section[section]);
        }
      }
      
      if(useCoachmark) {
        self.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
        
        const isCoachmarkDone = self.storage.getItem("coachmarkdone") ? JSON.parse(self.storage.getItem("coachmarkdone")) : null;
        if(!(isCoachmarkDone && self.step in isCoachmarkDone && isCoachmarkDone[self.step])) {
          self.showCoachMark();
        }
      }
      self.$store.dispatch("showLoading", false);
    })
    .catch(err => {
      self.$store.dispatch("showLoading", false);
    });
  },
  methods: {
    selectSection(section_name) {
      
      if(section_name == 'bunka') {
        // 暫定coming soon 対応
        return false
      }
      if(this.driver) {
        this.driver.reset();
      }
      
      this.$store.dispatch("setSectionData", this.$store.getters.section[section_name]);
      this.$store.dispatch("setSectionStatus", this.$store.getters.section[section_name].status);

      // Update status the first time
      if (this.$store.getters.section_status == "ready") {
        this.statusSection('start');
      }

      this.$router.push({ name: 'lesson.category', params: {category: section_name} });
    },
    initCoachMark() {
      if(this.driver) {
        this.driver.reset()
      } else {
        const driverOverlay = document.getElementById('driver-page-overlay')
        const driverStage = document.getElementById('driver-highlighted-element-stage')
        const driverItem = document.getElementById('driver-popover-item')
        const driverItem2 = document.getElementById('driver-popover-item2')
        
        if(driverOverlay) {
          driverOverlay.remove()
        }
        if(driverStage) {
          driverStage.remove()
        }
        if(driverItem) {
          driverItem.remove()
        }
      }
    },
    showCoachMark() {
      let self = this;
      if(!this.authUser) return false;
      
       this.driver = new Driver({
          className: "scoped-class-dark",
          animate: false,
          opacity: 0.7,
          padding: 10,
          stageBackground: 'rgba(255, 255, 255, 0.5)',
          allowClose: true,
          overlayClickNext: false,
          DoneBtnText: "Done",
          CloseBtnText: "Close",
          NextBtnText: "Next",
          PrevBtnText: "Previous step",
          onReset: (e) => {
            
            let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
            if(!coachMarks) {
              coachMarks = {};
              coachMarks[this.step] = true;
            } else {
              coachMarks[this.step] = true;
            }

            this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
          }
      })
      setTimeout(() => {
        this.driver.highlight({
          element: '.map-click.hiragana .flag-locked.flag-unlocked',
          popover: {
            className: 'popover-class',
            title: 'click to Start Lesson',
            position: 'top',
          }
        })
      },300)
    }
  },
};
</script>

<style scoped>
.main-bg {
  overflow: hidden;
}

.driver-fix-stacking.map-click.hiragana {
  z-index: 100004 !important;
}
</style>
